'use client'
import dynamic from 'next/dynamic'

const StaysToastContainer = dynamic(
  () => import('@/components/StaysToastContainer').then((m) => ({ default: m.StaysToastContainer })),
  { ssr: false }
)

export default function DeferredStaysToastContainer() {
  return <StaysToastContainer />
}
